/** * @name: create-app-modal * @author: weiyong * @date: 2022-12-28 23:41 *
@description：create-app-modal * @update: 2022-12-28 23:41 */
<template>
  <div class="create-app-modal">
    <a-modal
      v-model:visible="dialogVisible"
      :width="winWidth"
      class="create-app-modal-win"
      :title="t('选择用户')"
      :maskClosable="false"
    >
      <div
        class="flex-div wh100b"
        :class="(account||accountFlag) ? 'accountDiv' : 'noAccount'"
      >
        <div class="account-tree-list" v-if="(account||accountFlag)" style="width: 240px">
          <account-tree-show-panel
            @selItemRecord="selItemRecord"
            ref="accountBodyRef"
          />
        </div>
        <use-sel-main-panel
          style="flex: 1"
          :roleName="roleName"
          :configs="configs"
          ref="selMainPanel"
          :account="account"
          :multiple="multiple"
          :aptitudeCode="aptitudeCode"
          :selUserRecords="selUserRecords"
          :searchUserList="searchUserList"
          :showSearchDiv="showSearchDiv"
        />
      </div>
      <template #footer>
        <div class="create-app-modal-footer">
          <a-button type="default" @click="handleCancelWin"
            >{{ t("取消") }}
          </a-button>
          <a-button type="primary" v-if="allUser" style="width: 88px" @click="handleAllConfirm"
          >{{ t("所有人") }}
          </a-button>
          <a-button type="primary" style="width: 88px" @click="handleConfirm"
            >{{ t("确定") }}
          </a-button>
        </div>
      </template>
      <div v-if="closeTopQuery!==true && !account" class="search-input">
        <a-input
          style="width: 260px"
          @pressEnter="winUserSearch"
          allow-clear
          @change="changeSearchVal"
          v-model:value="userNameKey"
          :placeholder="t('输入名称关键字查询')"
        >
          <template #suffix>
            <a-tooltip :title="t('输入用户名称或者拼音进行查询')">
              <search-outlined
                @click="winUserSearch"
                style="color: rgba(0, 0, 0, 0.45)"
              />
            </a-tooltip>
          </template>
        </a-input>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  name: "user-sel-modal",
});
</script>

<script lang="ts" setup>
import AccountTreeShowPanel from "@/components/select-org-ctl/panelBody/account-tree-show-panel.vue";
import UseSelMainPanel from "../components/use-sel-main-panel.vue";
import {
  Modal as aModal,
  Button as aButton,
  Input as aInput,
  Tooltip as aTooltip,
} from "ant-design-vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { useVModel } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import { useSearchSel } from "../hooks/useSearchSel";
import {GoingNewUtils} from "xmgoing-utils";
import {CurrentUtils} from "xmgoing-server";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";

const winWidth = ref<number>(890);

const { t } = useI18n();
const emits = defineEmits(["update:visible", 'handleCancel',"selRecords"]);

const props:any = defineProps({
  configs:{},
  allUser:{},
  closeTopQuery:{
    type: Boolean,
    default: false,
  },
  hasDel: {
    type: Boolean,
    default: true,
  },
  multiple: {},
  account: {
    type: Boolean,
    default: false,
  },
  roleName:{},
  selUserRecords: {},
  visible: {
    type: Boolean,
    default: false,
  },
});
const { multiple,configs,roleName}: any = toRefs(props);
const { vuex } = useVuexState({sectionConfig: configs, vuexProps: ['aptitudeCode']})

const aptitudeCode = computed(() => {
  let res = "";
  if (unref(configs).queryAptitudeFlag === true || unref(configs).queryAptitudeFlag === 'true') {
    if (unref(vuex)['aptitudeCode'] && unref(vuex)['aptitudeCode'] !== "") {
      res = unref(vuex)['aptitudeCode'];
    } else if (unref(configs).aptitudeCode && unref(configs).aptitudeCode !== "") {
      res = unref(configs).aptitudeCode;
    }
    console.log('资质code为----------------', res)
  }
  return res;
})

const accountFlag=ref(false);
CurrentUtils._loadUser(false, (userJson) => {
   if(userJson.accountId==="000000"){
     accountFlag.value=true;
   }
})
if (props.account||unref(accountFlag) === true) {
  winWidth.value = 1100;
}
const selMainPanel: any = ref(null);
const {
  winUserSearch,
  userNameKey,
  changeSearchVal,
  showSearchDiv,
  searchUserList,
} = useSearchSel(multiple, "", null, selMainPanel, undefined, false, aptitudeCode);
const dialogVisible = useVModel(props, "visible", emits);

// 每次重新进入 清空选中数据
nextTick(() => {
  selMainPanel.value.clearSelUsers();
});

const selItemRecord = function ({ key }) {
  selMainPanel.value.flushOrgList({ key });
};
//点击取消按钮
const handleCancelWin = function () {
  emits("handleCancel", {  });
  dialogVisible.value = false;
};
//点击确定按钮
const handleConfirm = function () {
  const alreadySelUsers = selMainPanel.value.getSelUsers();
  emits("selRecords", { alreadySelUsers });
  if(GoingNewUtils.parseBoolean(unref(configs).clearSels)){
    selMainPanel.value.clearSelUsers();
  }
  nextTick(() => {
    dialogVisible.value = false;
  });
};
const handleAllConfirm = () => {
  const alreadySelUsers = [
    {
      "id": "allUser",
      userId:'allUser',
      "name": "所有人",
      "realName": "所有人",
    }
  ];
  emits("selRecords", { alreadySelUsers });
  if(GoingNewUtils.parseBoolean(unref(configs).clearSels)){
    selMainPanel.value.clearSelUsers();
  }
  nextTick(() => {
    dialogVisible.value = false;
  });
}
</script>

<style type="text/css" lang="less">
.create-app-modal-win {

  .ant-modal-footer{
    border-top: 0;
    padding-top: 0;
  }
  .search-input {
    position: absolute;
    z-index: 999;
    right: 50px;
    top: 14px;
  }
  .ant-modal-body {
    padding:0;
  }
  .ant-tabs-nav {
    margin-bottom: 0;
    padding-left: 12px;
    background-color: #f1f3f4;
  }
}
.customBtn {
  left: 60px;
  top: 12px;
  position: absolute;
}

.create-app-form {
  padding: var(--padding-common);
}

.create-app-modal-footer {
  display: flex;
  justify-content: center;
  padding-top: 12px;

  button {
    border-radius: 4px;
  }

  button:last-of-type {
    margin-left: 12px;
  }
}

.create-app-modal {
  /deep/ .ivu-modal .ivu-modal-header {
    line-height: var(--win-header-bar-height);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }
}
</style>
